"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof3 = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.starts-with");

var _typeof2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.regexp.split");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

require("core-js/modules/es6.regexp.replace");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _index = _interopRequireDefault(require("@/views/cms/customers/baseInfo/index"));

var _index2 = _interopRequireDefault(require("@/views/cms/customers/basicInfo/index"));

var _index3 = _interopRequireDefault(require("@/views/cms/customers/requirements/index"));

var _index4 = _interopRequireDefault(require("@/views/cms/customers/storeinto/index"));

var _index5 = _interopRequireDefault(require("@/views/cms/customers/followInfo/index"));

var _index6 = _interopRequireDefault(require("@/views/cms/customers/contractFollowInfo/index"));

var _index7 = _interopRequireDefault(require("@/views/cms/customers/contractBasicInfo/index"));

var _index8 = _interopRequireDefault(require("@/views/cms/customers/contractDesignInfo/index"));

var _index9 = _interopRequireDefault(require("@/views/cms/customers/contractSpecialApply/index"));

var _index10 = _interopRequireDefault(require("@/views/cms/customers/contractQuotationInfo/index"));

var _index11 = _interopRequireDefault(require("@/views/cms/customers/contractProductionTracking/index"));

var _index12 = _interopRequireDefault(require("@/views/cms/customers/contractAfterInfo/index"));

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _cust = _interopRequireWildcard(require("@/api/cust"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _vuex = require("vuex");

var _statCust = require("@/api/statCust");

var _request = _interopRequireDefault(require("@/utils/request"));

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _followInfo = _interopRequireDefault(require("@/api/followInfo"));

var _dictDetail = require("@/api/system/dictDetail");

var _Dict = _interopRequireDefault(require("@/components/Dict/Dict"));

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _ossUpload = _interopRequireDefault(require("@/views/cms/common/ossUpload"));

var _index13 = _interopRequireDefault(require("./orderRateChart/index"));

var _AddressCascader = _interopRequireDefault(require("@/views/cms/common/AddressCascader"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {};
var _default = {
  name: 'CustomersList',
  components: {
    BaseInfo: _index.default,
    BasicInfo: _index2.default,
    Requirements: _index3.default,
    StoreInto: _index4.default,
    FollowInfo: _index5.default,
    ContractFollowInfo: _index6.default,
    CommonUpload: _commonUpload.default,
    OssUpload: _ossUpload.default,
    OrderRateChart: _index13.default,
    ContractBasicInfo: _index7.default,
    ContractDesignInfo: _index8.default,
    ContractSpecialApply: _index9.default,
    ContractQuotationInfo: _index10.default,
    ContractProductionTracking: _index11.default,
    ContractAfterInfo: _index12.default,
    draggable: _vuedraggable.default,
    AddressCascader: _AddressCascader.default
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)()],
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '客户',
      url: 'api/cust/queryCust',
      idField: 'id',
      sort: 'id,desc',
      crudMethod: _objectSpread({}, _cust.default)
    });
  },
  dicts: ['order_type', 'contract_type', 'customer_status_button', 'contract_status_button', 'customer_list_display_fields'],
  created: function created() {
    var _this = this;

    this.$on('dictReady', function () {
      _this.initTableHeader();
    });
    var status = this.$route.query.status;

    if (status) {
      this.activeFilter = status;
      this.crud.query.custStatus = status; // CRUD混入会自动toQuery，且custStatus已设置，无需重复触发
    }
  },
  data: function data() {
    var _ref;

    var validPhone = function validPhone(rule, value, callback) {
      if (!value) {
        callback();
      } else if (!/^\d{11}$/.test(value)) {
        callback(new Error('手机号码必须是11位数字'));
      } else {
        // 不需要接口验证手机号是否存在
        callback();
      }
    }; // 地址验证（同结构）


    var validAddress = function validAddress(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入地址'));
      } else {
        // 不需要接口验证地址是否存在
        callback();
      }
    }; // 微信号验证（同结构）


    var validWechat = function validWechat(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        // 不需要接口验证微信号是否存在
        callback();
      }
    };

    return _ref = {
      tableHeader: [],
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      screenWidth: document.documentElement.clientWidth || document.body.clientWidth,
      activeFilter: '',
      auditStatusMap: {
        1: '待审计',
        2: '已审计'
      },
      showContractForm: false,
      showContractTable: true,
      configDialogVisible: false,
      originalHeaderConfig: [],
      orderRateDialogVisible: false,
      searchForm: {
        customerName: '',
        phone: '',
        status: ''
      },
      salesmen: [{
        id: 1,
        name: '张导购'
      }, {
        id: 2,
        name: '王导购'
      }, {
        id: 3,
        name: '李设计师'
      }],
      dialogVisible: false,
      dialogTitle: '新增客户',
      customerForm: {
        id: '',
        name: '',
        phone: '',
        district: '',
        address: '',
        source: '',
        lastContact: new Date().toISOString().slice(0, 19).replace('T', ' ')
      },
      formRules: {
        name: [{
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '姓名长度在 2 到 20 个字符',
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '联系电话不能为空',
          trigger: 'blur'
        }, {
          trigger: 'blur',
          validator: validPhone
        }],
        source: [{
          required: true,
          message: '请选择客户来源',
          trigger: 'change'
        }],
        district: [{
          required: true,
          message: '请选择所在地区',
          trigger: 'change'
        }],
        address: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        msgFrom: [],
        isDistributor: [{
          required: true,
          message: '是否经销商区域不能为空',
          trigger: 'change'
        }],
        custWechat: [{
          required: true,
          message: '客户微信不能为空',
          trigger: 'blur'
        }, {
          trigger: 'blur',
          validator: validWechat
        }]
      },
      // 折叠状态管理
      collapsedCustomers: [],
      allExpanded: false,
      // 合同数据
      contracts: {},
      // 客户统计数据
      customerStatistics: {
        total: 0,
        following: 0,
        noOrder: 0,
        ordered: 0,
        completed: 0,
        afterSales: 0
      },
      // 分页数据
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 合同管理相关
      activeCollapse: ['1']
    }, (0, _defineProperty2.default)(_ref, "showContractForm", false), (0, _defineProperty2.default)(_ref, "showContractEditDialog", false), (0, _defineProperty2.default)(_ref, "followDialogVisible", false), (0, _defineProperty2.default)(_ref, "activeFollowTab", 'basicInfo'), (0, _defineProperty2.default)(_ref, "currentCustomer", {}), (0, _defineProperty2.default)(_ref, "followForm", {
      // 基本信息
      baseInfo: {
        name: '',
        mobile: '',
        exMobile: '',
        gender: '',
        msgFrom: '',
        businessFrom: '',
        address: '',
        custWechat: '',
        taobaoName: ''
      },
      // 门店信息
      storeInfo: {
        storeName: '',
        storeManager: '',
        isDistributor: '',
        inviter: '',
        remarks: ''
      },
      // 客户需求
      requirements: {
        housePrice: '',
        houseArea: '',
        style: '',
        moveInTime: '',
        productNeed: '',
        customerFocus: '',
        customerLevel: '',
        decorationStatus: '',
        deliveryTime: '',
        decorationType: ''
      },
      // 客户基本情况
      basicInfo: {
        focus: '',
        needProduct1: [],
        needProduct2: [],
        needProduct3: [],
        budget: '',
        material: '',
        budgetImgs: [],
        remark: ''
      },
      // 量房信息
      measureInfo: {
        measureTime: '',
        measureUser: '',
        houseType: '',
        houseArea: '',
        measureImgs: [],
        remarks: ''
      },
      // 设计信息
      designInfo: {
        designUser: '',
        styleFocus: '',
        needProduct1: [],
        needProduct2: [],
        needProduct3: [],
        budget: '',
        material: [],
        designImgs: [],
        remarks: ''
      },
      // 跟进记录
      followInfo: {
        list: []
      }
    }), (0, _defineProperty2.default)(_ref, "designActiveNames", ['1', '2', '3']), (0, _defineProperty2.default)(_ref, "tempFollow", {
      followTime: '',
      followUser: '',
      content: '',
      followImgs: []
    }), (0, _defineProperty2.default)(_ref, "followRecords", []), (0, _defineProperty2.default)(_ref, "followImgDialogVisible", false), (0, _defineProperty2.default)(_ref, "previewImgUrl", ''), (0, _defineProperty2.default)(_ref, "followCustService", ''), (0, _defineProperty2.default)(_ref, "custAllotUser", ''), (0, _defineProperty2.default)(_ref, "editingContractId", null), (0, _defineProperty2.default)(_ref, "dealerShopList", []), (0, _defineProperty2.default)(_ref, "dealerList", []), (0, _defineProperty2.default)(_ref, "contractForm", {
      id: '',
      contractNo: '',
      dealerCode: '',
      dealer: '',
      dealerShopCode: '',
      dealerShopName: '',
      type: '',
      customerName: '',
      customerPhone: '',
      contractAmount: 0,
      budgetAmount: 0,
      address: '',
      unmeasured: '否',
      images: [],
      attachments: []
    }), (0, _defineProperty2.default)(_ref, "contractRules", {
      dealerShopCode: [{
        required: true,
        message: '请选择门店',
        trigger: 'change'
      }],
      contractNo: [{
        required: false,
        message: '请输入合同号',
        trigger: 'blur'
      }],
      type: [{
        required: true,
        message: '请选择合同类型',
        trigger: 'change'
      }],
      customerName: [{
        required: true,
        message: '请输入客户姓名',
        trigger: 'blur'
      }],
      customerPhone: [{
        required: true,
        message: '请输入客户电话',
        trigger: 'blur'
      }],
      address: [{
        required: true,
        message: '请输入客户地址',
        trigger: 'blur'
      }],
      contractAmount: [{
        required: true,
        message: '请输入合同金额',
        trigger: 'blur'
      }, {
        type: 'number',
        min: 0.01,
        message: '金额必须大于0',
        trigger: 'blur'
      }]
    }), (0, _defineProperty2.default)(_ref, "customers", []), (0, _defineProperty2.default)(_ref, "previewVisible", false), (0, _defineProperty2.default)(_ref, "previewImages", []), (0, _defineProperty2.default)(_ref, "zoomScale", 1), (0, _defineProperty2.default)(_ref, "previewFilesVisible", false), (0, _defineProperty2.default)(_ref, "previewFiles", []), (0, _defineProperty2.default)(_ref, "showContractViewDialog", false), (0, _defineProperty2.default)(_ref, "currentContract", {}), (0, _defineProperty2.default)(_ref, "activeContractTab", 'basic'), (0, _defineProperty2.default)(_ref, "contractViewImages", []), (0, _defineProperty2.default)(_ref, "contractViewFiles", []), (0, _defineProperty2.default)(_ref, "previewImageVisible", false), (0, _defineProperty2.default)(_ref, "previewImageUrl", ''), (0, _defineProperty2.default)(_ref, "exportLoading", false), (0, _defineProperty2.default)(_ref, "createDateRange", []), (0, _defineProperty2.default)(_ref, "planMeasureTimeRange", []), (0, _defineProperty2.default)(_ref, "contractTimeRange", []), (0, _defineProperty2.default)(_ref, "showMoreSearch", false), _ref;
  },
  computed: _objectSpread(_objectSpread({
    tableHeight: function tableHeight() {
      return this.screenHeight * (this.showMoreSearch ? 0.46 : 0.55);
    },
    dialogWidth: function dialogWidth() {
      return this.screenWidth * 0.7 + 'px';
    },
    contractEditable: function contractEditable() {
      return this.currentContract && this.currentContract.isArchive !== 1;
    }
  }, (0, _vuex.mapState)({
    imgPreviewPrefix: function imgPreviewPrefix(state) {
      return state.api.imgPreviewPrefix;
    }
  })), {}, {
    visibleColumns: {
      get: function get() {
        return this.tableHeader.filter(function (col) {
          return col.visible;
        });
      },
      set: function set(val) {
        var visibleKeys = val.map(function (col) {
          return col.key;
        });
        this.tableHeader = [].concat((0, _toConsumableArray2.default)(val), (0, _toConsumableArray2.default)(this.tableHeader.filter(function (col) {
          return !col.visible;
        })));
      }
    },
    crudPage: function crudPage() {
      return this.crud && this.crud.page ? this.crud.page : {
        page: 1,
        size: 10,
        total: 0
      };
    },
    followingCount: function followingCount() {
      return this.customers.filter(function (customer) {
        return customer.status === 'following';
      }).length;
    },
    noOrderCount: function noOrderCount() {
      return this.customers.filter(function (customer) {
        return customer.status === 'noOrder';
      }).length;
    },
    orderedCount: function orderedCount() {
      return this.customers.filter(function (customer) {
        return customer.status === 'ordered';
      }).length;
    },
    completedCount: function completedCount() {
      return this.customers.filter(function (customer) {
        return customer.status === 'completed';
      }).length;
    },
    afterSalesCount: function afterSalesCount() {
      return this.customers.filter(function (customer) {
        return customer.status === 'afterSales';
      }).length;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var rq = to.query || {};

      if (rq.planMeasureTimeBegin || rq.planMeasureTimeEnd) {
        this.initPlanMeasureQuery(rq);
      } else {
        var status = rq.status;

        if (status) {
          this.activeFilter = status;
          this.crud.query.custStatus = status;
          this.crud.toQuery();
        } else {
          this.activeFilter = '';
          this.crud.query.custStatus = '';
          this.crud.toQuery();
        }
      }
    },
    crudPage: {
      handler: function handler(newVal) {
        if (newVal && newVal.total !== undefined) {
          this.total = newVal.total;
        }
      },
      immediate: true,
      deep: true
    },
    'crud.loading': function crudLoading(newVal, oldVal) {
      if (oldVal === true && newVal === false && this.needFilterQuery) {
        this.crud.toQuery();
        this.needFilterQuery = false;
      }
    }
  },
  mounted: function mounted() {
    this.loadCustomerStatistics();
    this.loadHeaderConfig();
    window.addEventListener('resize', this.handleResize); // 如果路由带有计划测量时间参数，从路由初始化筛选值（支持从首页跳转）

    try {
      var rq = this.$route && this.$route.query ? this.$route.query : {};
      var b = rq.planMeasureTimeBegin;
      var e = rq.planMeasureTimeEnd;

      if (b || e) {
        var begin = b || e || '';
        var end = e || b || ''; // 设置显示范围：如果带有时间部分，截取日期部分用于日期选择器显示

        var beginDate = begin.split(' ')[0];
        var endDate = end.split(' ')[0];

        if (beginDate && endDate) {
          this.planMeasureTimeRange = [beginDate, endDate];
        } // 保留原始值（可能包含时间）用于后端查询


        this.$set(this.query, 'planMeasureTimeBegin', begin);
        this.$set(this.query, 'planMeasureTimeEnd', end); // 触发一次查询以应用路由筛选

        this.crud.toQuery();
      }
    } catch (e) {
      console.error('初始化路由计划测量时间失败', e);
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: (_methods = {
    handleResize: function handleResize() {
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
      this.screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.query.page = 0;
      this.query.size = size;
      this.currentPage = 1;
      this.crud.toQuery();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.query.page = page - 1;
      this.crud.toQuery();
    },
    // 初始化表头配置
    initTableHeader: function initTableHeader() {
      var fields = this.dict.customer_list_display_fields.filter(function (item) {
        return item.value && item.label;
      }); // 按 value 去重，避免重复 key 导致 Vue 报错

      var seen = new Set();
      var uniqueFields = fields.filter(function (item) {
        if (seen.has(item.value)) {
          console.warn('发现重复的字典值:', item.value);
          return false;
        }

        seen.add(item.value);
        return true;
      });
      this.tableHeader = (0, _toConsumableArray2.default)(uniqueFields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      }));
      this.loadHeaderConfig();
    },
    // 加载表头配置
    loadHeaderConfig: function loadHeaderConfig() {
      var _this2 = this;

      var savedConfig = localStorage.getItem('customerHeaderConfig');

      if (savedConfig) {
        try {
          var config = JSON.parse(savedConfig);
          config.forEach(function (item) {
            var col = _this2.tableHeader.find(function (col) {
              return col.key === item.key;
            });

            if (col) {
              col.visible = item.visible;
              col.sort = item.sort !== undefined ? item.sort : col.sort;
            }
          });
          this.tableHeader.sort(function (a, b) {
            return a.sort - b.sort;
          });
        } catch (e) {
          console.error('加载表头配置失败:', e);
        }
      }
    },
    // ✅ 新增这个钩子方法，数据加载后自动折叠所有
    afterCrudRefresh: function afterCrudRefresh() {
      var _this3 = this;

      // 清空旧的折叠ID，避免和新数据ID冲突
      this.collapsedCustomers = []; // 遍历新的crud.data，把每个客户ID加入折叠数组

      this.crud.data.forEach(function (customer) {
        _this3.collapsedCustomers.push(customer.id);
      });
    },
    // 获取标签类型
    getTagType: function getTagType(status) {
      var typeMap = {
        '待跟进': 'info',
        '跟进中': 'warning',
        '待签单': '',
        '已签单': 'success',
        '待下单': 'info',
        '已下单': 'success'
      };
      return typeMap[status] || 'primary';
    },
    // 获取统计数量
    getStatisticsCount: function getStatisticsCount(status) {
      // 从字典中查找对应状态的unit
      var statusItem = this.dict.customer_status_button.find(function (item) {
        return item.value === status;
      });

      if (statusItem && statusItem.unit) {
        return this.customerStatistics[statusItem.unit] || 0;
      }

      return 0;
    },
    // 加载客户统计数据
    loadCustomerStatistics: function loadCustomerStatistics() {
      var _this4 = this;

      var params = {};
      var queryKeys = ['custId', 'name', 'mobile', 'contractNo', 'storeName', 'storeSellerNick', 'sjName', 'address', 'custStatus', 'isArchive', 'isAudit', 'unmeasured', 'createDateBegin', 'createDateEnd', 'planMeasureTimeBegin', 'planMeasureTimeEnd', 'contractTimeBegin', 'contractTimeEnd'];
      queryKeys.forEach(function (key) {
        var value = _this4.query[key];

        if (value !== undefined && value !== null && value !== '') {
          params[key] = typeof value === 'string' ? value.trim() : value;
        }
      });
      (0, _statCust.getCustStatistics)(params).then(function (response) {
        if (response) {
          _this4.customerStatistics = response;
        }
      }).catch(function (error) {});
    },
    // 不再需要 loadContracts 方法，因为现在直接使用 customer.contracts
    // 解析合同图片数据
    parseContractImgs: function parseContractImgs(contractImgs) {
      if (!contractImgs) {
        return [];
      }

      try {
        return JSON.parse(contractImgs);
      } catch (e) {
        return [];
      }
    },
    // 解析合同附件数据
    parseContractFiles: function parseContractFiles(fileData) {
      if (!fileData) {
        return [];
      }

      try {
        return JSON.parse(fileData);
      } catch (e) {
        return [];
      }
    },
    // 获取文件名
    getFileName: function getFileName(fileUrl) {
      if (!fileUrl) {
        return '';
      }

      var parts = fileUrl.split('/');
      return parts[parts.length - 1];
    },
    // 预览合同图片
    previewContractImgs: function previewContractImgs(contractImgs) {
      try {
        var imgs = JSON.parse(contractImgs); // 获取全局的文件域名前缀

        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        this.previewImages = imgs.map(function (img) {
          return {
            url: "".concat(imgPreviewPrefix).concat(img.realName),
            name: img.alias || img.realName,
            alias: img.alias,
            realName: img.realName
          };
        });
        this.previewVisible = true;
      } catch (e) {}
    },
    handleZoomIn: function handleZoomIn() {
      this.zoomScale = Math.min(this.zoomScale + 0.2, 3);
    },
    handleZoomOut: function handleZoomOut() {
      this.zoomScale = Math.max(this.zoomScale - 0.2, 0.2);
    },
    resetZoom: function resetZoom() {
      this.zoomScale = 1;
    },
    handleDownload: function handleDownload(img) {
      var _this5 = this;

      var fileName = img.alias || img.name || img.realName || 'image';
      (0, _cmsWorkOrder.downloadOssFile)({
        realName: img.realName || fileName,
        type: '图片'
      }).then(function (res) {
        var blobUrl = URL.createObjectURL(res);
        var link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }).catch(function () {
        _this5.$message.error('下载失败，请重试');
      });
    },
    handleFileDownload: function handleFileDownload(file) {
      var _this6 = this;

      var fileName = file.alias || file.name || file.realName || 'file';
      (0, _cmsWorkOrder.downloadOssFile)({
        realName: file.realName || fileName,
        type: '附件'
      }).then(function (res) {
        var blobUrl = URL.createObjectURL(res);
        var link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }).catch(function () {
        _this6.$message.error('下载失败，请重试');
      });
    },
    // 预览合同附件
    previewContractFiles: function previewContractFiles(fileData) {
      try {
        var files = JSON.parse(fileData); // 获取全局的文件域名前缀

        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        this.previewFiles = files.map(function (file) {
          return {
            url: "".concat(filePreviewPrefix).concat(file.realName),
            name: file.alias || file.realName,
            alias: file.alias,
            realName: file.realName
          };
        });
        this.previewFilesVisible = true;
      } catch (e) {}
    },
    // 在新窗口打开文件
    openFileInNewWindow: function openFileInNewWindow(url, realName) {
      try {
        var fileUrl = url;

        if (!fileUrl && realName) {
          // 如果没有url，使用filePreviewPrefix和realName构建完整URL
          var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
          fileUrl = filePreviewPrefix + realName;
        }

        if (fileUrl) {
          window.open(fileUrl, '_blank');
        } else {
          this.$message.error('文件URL为空，无法打开');
        }
      } catch (e) {
        this.$message.error('打开失败，请重试');
      }
    },
    // 处理添加子合同
    handleAddSubcontract: function handleAddSubcontract(contract) {
      var _this7 = this;

      this.$confirm('确定要为该主合同添加子合同吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 从合同对象中获取客户ID
        var custId = contract.custId; // 调用新增子合同接口

        (0, _cmsWorkOrder.addSubcontract)({
          id: contract.id
        }).then(function (response) {
          if (response.code === 200) {
            _this7.$message.success('子合同添加成功'); // 刷新客户信息，确保合同列表顺序正确


            if (custId) {
              (0, _cmsWorkOrder.getCustInfo)(custId).then(function (response) {
                if (response && response.code === 200 && response.data) {
                  var latestCustomer = response.data;
                  _this7.currentCustomer = _objectSpread({}, latestCustomer); // 重新初始化表单数据

                  _this7.initFollowForm(latestCustomer); // 重新加载跟进记录


                  _this7.loadFollowRecords(latestCustomer.id); // 直接更新本地数据中的客户信息，不刷新页面


                  var index = _this7.crud.data.findIndex(function (c) {
                    return c.id === latestCustomer.id;
                  });

                  if (index !== -1) {
                    _this7.$set(_this7.crud.data, index, latestCustomer);
                  } // 刷新上传组件


                  if (_this7.$refs.basicInfo) {
                    _this7.$refs.basicInfo.init();
                  }
                }
              }).catch(function (error) {});
            } else {}
          } else {
            _this7.$message.error(response.msg || '添加子合同失败');
          }
        }).catch(function (error) {
          console.error('添加子合同失败:', error);

          _this7.$message.error('添加子合同失败，请重试');
        });
      }).catch(function () {// 取消操作
      });
    },
    handleQuickFilter: function handleQuickFilter(filter) {
      this.activeFilter = filter;
      this.query.custStatus = filter;
      this.searchCustomers(); // 筛选后更新统计数据

      this.loadCustomerStatistics();
    },
    searchCustomers: function searchCustomers() {
      this.currentPage = 1;
      this.query.page = 0;
      if (this.query.name) this.query.name = this.query.name.trim();
      if (this.query.custId !== undefined && this.query.custId !== null && this.query.custId !== '') this.query.custId = String(this.query.custId).trim();
      if (this.query.mobile) this.query.mobile = this.query.mobile.trim();
      if (this.query.contractNo) this.query.contractNo = this.query.contractNo.trim();
      if (this.query.storeName) this.query.storeName = this.query.storeName.trim();
      if (this.query.storeSellerNick) this.query.storeSellerNick = this.query.storeSellerNick.trim();
      if (this.query.sjName) this.query.sjName = this.query.sjName.trim();
      if (this.query.address) this.query.address = this.query.address.trim(); // 创建时间范围

      if (this.createDateRange && this.createDateRange.length === 2) {
        this.$set(this.query, 'createDateBegin', this.createDateRange[0]);
        this.$set(this.query, 'createDateEnd', this.createDateRange[1]);
      } else {
        this.$set(this.query, 'createDateBegin', '');
        this.$set(this.query, 'createDateEnd', '');
      }

      if (this.planMeasureTimeRange && this.planMeasureTimeRange.length === 2) {
        // 将选择的日期范围补上时间，发送给后端完整时间区间
        var beginDate = this.planMeasureTimeRange[0];
        var endDate = this.planMeasureTimeRange[1];
        var beginDateTime = beginDate + ' 00:00:00';
        var endDateTime = endDate + ' 23:59:59';
        this.$set(this.query, 'planMeasureTimeBegin', beginDateTime);
        this.$set(this.query, 'planMeasureTimeEnd', endDateTime);
      } else {
        this.$set(this.query, 'planMeasureTimeBegin', '');
        this.$set(this.query, 'planMeasureTimeEnd', '');
      } // contractTime 范围


      if (this.contractTimeRange && this.contractTimeRange.length === 2) {
        var _beginDate = this.contractTimeRange[0];
        var _endDate = this.contractTimeRange[1];
        this.$set(this.query, 'contractTimeBegin', _beginDate + ' 00:00:00');
        this.$set(this.query, 'contractTimeEnd', _endDate + ' 23:59:59');
      } else {
        this.$set(this.query, 'contractTimeBegin', '');
        this.$set(this.query, 'contractTimeEnd', '');
      }

      this.crud.toQuery(); // 搜索后更新统计数据

      this.loadCustomerStatistics();
    },
    handleExport: function handleExport() {
      var _this8 = this;

      var params = {};
      var queryKeys = ['custId', 'name', 'mobile', 'custStatus', 'contractNo', 'contractStatus', 'storeName', 'storeSellerNick', 'sjName', 'address', 'isArchive', 'isAudit', 'unmeasured', 'createDateBegin', 'createDateEnd', 'planMeasureTimeBegin', 'planMeasureTimeEnd', 'contractTimeBegin', 'contractTimeEnd'];
      queryKeys.forEach(function (key) {
        var value = _this8.query[key];

        if (value !== undefined && value !== null && value !== '') {
          params[key] = typeof value === 'string' ? value.trim() : value;
        }
      });
      this.exportLoading = true;
      (0, _cust.downloadCustList)(params).then(function (res) {
        var blob = new Blob([res]);
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        var contentDisposition = res.headers && res.headers['content-disposition'];
        var fileName = '客户数据.xlsx';

        if (contentDisposition) {
          var match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

          if (match && match[1]) {
            fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
          }
        }

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        _this8.$message.success('导出成功');
      }).catch(function () {
        _this8.$message.error('导出失败，请重试');
      }).finally(function () {
        _this8.exportLoading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.$set(this.query, 'name', '');
      this.$set(this.query, 'custId', '');
      this.$set(this.query, 'mobile', '');
      this.$set(this.query, 'custStatus', '');
      this.$set(this.query, 'contractNo', '');
      this.$set(this.query, 'contractStatus', '');
      this.$set(this.query, 'storeName', '');
      this.$set(this.query, 'storeSellerNick', '');
      this.$set(this.query, 'sjName', '');
      this.$set(this.query, 'address', '');
      this.$set(this.query, 'isArchive', '');
      this.$set(this.query, 'isAudit', '');
      this.$set(this.query, 'unmeasured', '');
      this.$set(this.query, 'createDateBegin', '');
      this.$set(this.query, 'createDateEnd', '');
      this.$set(this.query, 'planMeasureTimeBegin', '');
      this.$set(this.query, 'planMeasureTimeEnd', '');
      this.$set(this.query, 'contractTimeBegin', '');
      this.$set(this.query, 'contractTimeEnd', '');
      this.activeFilter = '';
      this.createDateRange = [];
      this.planMeasureTimeRange = [];
      this.contractTimeRange = [];
      this.showMoreSearch = false;
      this.crud.toQuery(); // 重置后更新统计数据

      this.loadCustomerStatistics();
    },
    handleCreateCustomer: function handleCreateCustomer() {
      this.dialogTitle = '新增客户';
      this.customerForm = {
        id: '',
        name: '',
        phone: '',
        district: '',
        address: '',
        source: '',
        status: 'following',
        lastContact: new Date().toISOString().slice(0, 19).replace('T', ' ')
      };
      this.dialogVisible = true;
    },
    // 客户跟进
    handleFollow: function handleFollow(customer) {
      var _this9 = this;

      this.followDialogVisible = true;
      this.activeFollowTab = 'followInfo'; // 先查询完整客户信息（包含followInfo等关联数据）

      (0, _cmsWorkOrder.getCustInfo)(customer.id).then(function (response) {
        if (response && response.code === 200 && response.data) {
          var fullCustomer = response.data;
          _this9.currentCustomer = _objectSpread({}, fullCustomer);

          _this9.initFollowForm(fullCustomer);
        } else {
          _this9.currentCustomer = _objectSpread({}, customer);

          _this9.initFollowForm(customer);
        }
      }).catch(function () {
        _this9.currentCustomer = _objectSpread({}, customer);

        _this9.initFollowForm(customer);
      }); // 调用跟进查询接口，加载跟进数据

      this.$nextTick(function () {
        if (_this9.$refs.followInfo) {
          _this9.$refs.followInfo.init(customer.id);
        }
      });
    },
    // 获取提交人员昵称列表
    getPromoterNickNames: function getPromoterNickNames(customer) {
      var promoters = [];

      if (customer.custUserMappings && Array.isArray(customer.custUserMappings)) {
        var _iterator = _createForOfIteratorHelper(customer.custUserMappings),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var user = _step.value;

            if (user.type === '推广' && user.user && user.user.nickName) {
              promoters.push(user.user.nickName);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return promoters;
    },
    // 处理特殊申请
    handleSpecialApply: function handleSpecialApply(contract) {
      console.log("contract:", contract); // 检查用户是否有特殊申请权限

      if (!this.checkPer(['admin', 'contracts:specialApply'])) {
        this.$message.error('您没有特殊申请权限');
        return;
      } // 找到包含该合同的客户，获取客户信息


      var customer = this.crud.data.find(function (cust) {
        return cust.contracts.some(function (c) {
          return c.id === contract.id;
        });
      }); // 合并客户信息到合同数据中

      if (customer) {
        this.currentCustomer = customer;
        this.currentContract = _objectSpread(_objectSpread({}, contract), {}, {
          customerName: customer.name,
          customerPhone: customer.mobile,
          address: customer.address
        });
      } else {
        this.currentContract = contract;
      } // 处理合同图片


      try {
        var imgs = JSON.parse(contract.contractImgs || '[]'); // 获取全局的文件域名前缀

        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        this.contractViewImages = imgs.map(function (img) {
          return {
            url: "".concat(imgPreviewPrefix).concat(img.realName),
            name: img.realName
          };
        });
      } catch (e) {
        this.contractViewImages = [];
      } // 处理合同附件


      try {
        var files = JSON.parse(contract.file || '[]'); // 获取全局的文件域名前缀

        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        this.contractViewFiles = files.map(function (file) {
          return {
            url: "".concat(filePreviewPrefix).concat(file.realName),
            name: file.alias || file.realName
          };
        });
      } catch (e) {
        this.contractViewFiles = [];
      } // 打开合同详情弹窗


      this.showContractViewDialog = true; // 默认选中特殊申请标签页

      this.activeContractTab = 'special';
    },
    // 处理客户信息变化
    handleBaseInfoChange: function handleBaseInfoChange(data) {
      this.followForm.baseInfo = _objectSpread({}, data);
    },
    // 处理客户基本情况变化
    handleBasicInfoChange: function handleBasicInfoChange(data) {
      this.followForm.basicInfo = _objectSpread({}, data);
    },
    // 处理更新currentCustomer
    handleUpdateCurrentCustomer: function handleUpdateCurrentCustomer(updatedCustomer) {
      this.currentCustomer = _objectSpread({}, updatedCustomer); // 重新加载主页面客户列表

      this.crud.toQuery();
    },
    // 处理合同设计信息变更
    handleContractDesignInfoChange: function handleContractDesignInfoChange(data) {
      var _this10 = this;

      if (data && data.custId) {
        (0, _cmsWorkOrder.getCustInfo)(data.custId).then(function (response) {
          if (response && response.code === 200 && response.data) {
            var latestCustomer = response.data;
            _this10.currentCustomer = _objectSpread({}, latestCustomer);

            var index = _this10.crud.data.findIndex(function (c) {
              return c.id === data.custId;
            });

            if (index !== -1) {
              _this10.$set(_this10.crud.data, index, latestCustomer);
            }

            if (latestCustomer.contracts && _this10.currentContract.id) {
              var contract = latestCustomer.contracts.find(function (c) {
                return c.id === _this10.currentContract.id;
              });

              if (contract) {
                _this10.currentContract = _objectSpread({}, contract);
              }
            }
          }
        });
      }
    },
    // 处理合同数据刷新
    handleRefreshContractData: function handleRefreshContractData(contractData) {
      if (contractData && this.currentContract) {
        this.currentContract = _objectSpread({}, contractData);
        this.updateContractInLists(contractData.id, contractData);
      }
    },
    // 更新所有列表中的合同数据
    updateContractInLists: function updateContractInLists(contractId, data) {
      if (this.currentCustomer && this.currentCustomer.contracts) {
        var contractIndex = this.currentCustomer.contracts.findIndex(function (c) {
          return c.id === contractId;
        });

        if (contractIndex !== -1) {
          this.currentCustomer.contracts[contractIndex] = _objectSpread(_objectSpread({}, this.currentCustomer.contracts[contractIndex]), data);
        }
      }

      if (this.crud && this.crud.data) {
        this.crud.data.forEach(function (customer) {
          if (customer.contracts) {
            var _contractIndex = customer.contracts.findIndex(function (c) {
              return c.id === contractId;
            });

            if (_contractIndex !== -1) {
              customer.contracts[_contractIndex] = _objectSpread(_objectSpread({}, customer.contracts[_contractIndex]), data);
            }
          }
        });
      }
    },
    // 处理门店数据刷新
    handleRefreshStoreData: function handleRefreshStoreData(storeData) {
      if (storeData && this.currentCustomer) {
        this.currentCustomer = _objectSpread({}, storeData); // 重新加载主页面客户列表

        this.crud.toQuery();
      }
    },
    // 从新增客户弹窗新增合同
    handleAddContractFromCustomerDialog: function handleAddContractFromCustomerDialog() {
      this.showContractForm = !this.showContractForm;

      if (this.showContractForm) {
        this.loadDealerShopList(); // 初始化合同表单（不再拼接地区，直接使用详细地址）

        this.contractForm = {
          customerId: this.customerForm.id,
          customerName: this.customerForm.name,
          customerPhone: this.customerForm.mobile,
          address: this.customerForm.address || '',
          contractNo: '',
          dealerCode: '',
          dealer: '',
          dealerShopCode: '',
          dealerShopName: '',
          unmeasured: '否',
          contractAmount: 0,
          budgetAmount: 0,
          contractImgs: '',
          file: ''
        };
        this.loadDealerList();
      }
    },
    toggleContractTable: function toggleContractTable() {
      this.showContractTable = !this.showContractTable;
    },
    resetContractForm: function resetContractForm() {
      // 重置合同表单
      this.$refs.contractForm.resetFields(); // 初始化合同表单

      this.contractForm = {
        customerId: this.customerForm.id,
        custId: this.customerForm.id,
        customerName: '',
        customerPhone: '',
        address: '',
        contractNo: '',
        dealerCode: '',
        dealer: '',
        dealerShopCode: '',
        dealerShopName: '',
        unmeasured: '否',
        contractAmount: 0,
        budgetAmount: 0,
        contractImgs: '',
        file: ''
      };
    },
    editContract: function editContract(row) {// 编辑合同逻辑
    },
    deleteContract: function deleteContract(row) {// 删除合同逻辑
    },
    // 重新查询客户数据
    refreshCustomerData: function refreshCustomerData() {
      var _this11 = this;

      // 重新加载当前客户数据
      if (this.currentCustomer && this.currentCustomer.id) {
        (0, _cmsWorkOrder.getCustInfo)(this.currentCustomer.id).then(function (response) {
          if (response) {
            // 保存原有客户数据的合同顺序
            var originalCustomer = _this11.crud.data && _this11.crud.data.find(function (c) {
              return c.id === _this11.currentCustomer.id;
            });

            var originalContractOrder = originalCustomer && originalCustomer.contracts ? originalCustomer.contracts.map(function (c) {
              return c.id;
            }) : []; // 如果有原有合同顺序，按照该顺序重新排序新的合同数据

            if (originalContractOrder.length > 0 && response.contracts && response.contracts.length > 0) {
              response.contracts.sort(function (a, b) {
                var indexA = originalContractOrder.indexOf(a.id);
                var indexB = originalContractOrder.indexOf(b.id);
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
              });
            } // 更新当前客户数据


            _this11.currentCustomer = response; // 更新crud.data中的对应客户数据，保持列表顺序不变

            if (_this11.crud && _this11.crud.data) {
              var customerIndex = _this11.crud.data.findIndex(function (c) {
                return c.id === _this11.currentCustomer.id;
              });

              if (customerIndex !== -1) {
                // 只更新对应索引的客户数据，不改变列表顺序
                _this11.crud.data.splice(customerIndex, 1, response);
              }
            } // 更新当前合同数据


            if (_this11.currentContract && _this11.currentContract.id) {
              var updatedContract = response.contracts && response.contracts.find(function (c) {
                return c.id === _this11.currentContract.id;
              });

              if (updatedContract) {
                _this11.currentContract = _objectSpread(_objectSpread({}, updatedContract), {}, {
                  customerName: response.name,
                  customerPhone: response.mobile,
                  address: response.address
                });
              }
            }
          } else {
            console.error('重新获取客户数据失败: 响应为空');
          }
        }).catch(function (error) {
          console.error('重新获取客户数据失败:', error);
        });
      }
    },
    // 解析数组字段
    parseArrayField: function parseArrayField(field) {
      if (!field) return '';
      if (Array.isArray(field)) return field.join(', ');

      if (typeof field === 'string') {
        try {
          var parsed = JSON.parse(field);
          if (Array.isArray(parsed)) return parsed.join(', ');
          return field;
        } catch (e) {
          return field;
        }
      }

      return field;
    },
    // 保存全部客户信息
    saveFollowInfo: function saveFollowInfo() {
      var _this12 = this;

      // 触发子组件的syncData方法，确保包含新上传的图片
      if (this.$refs.basicInfo) {
        this.$refs.basicInfo.syncData();
      } // 构建保存的数据对象


      var saveData = {
        id: this.currentCustomer.id,
        // 客户基本信息
        name: this.followForm.baseInfo.name,
        mobile: this.followForm.baseInfo.mobile,
        address: this.followForm.baseInfo.address,
        custWechat: this.followForm.baseInfo.custWechat,
        isDistributor: this.followForm.baseInfo.isDistributor,
        inviter: this.followForm.baseInfo.inviter,
        msgFrom: this.followForm.baseInfo.msgFrom,
        zxFrom: this.followForm.baseInfo.zxFrom,
        // 客户基本情况
        styleFocus: this.followForm.basicInfo.focus,
        needProduct1: JSON.stringify(this.followForm.basicInfo.needProduct1),
        needProduct2: JSON.stringify(this.followForm.basicInfo.needProduct2),
        needProduct3: JSON.stringify(this.followForm.basicInfo.needProduct3),
        budget: this.followForm.basicInfo.budget,
        material: this.followForm.basicInfo.material,
        budgetImgs: this.followForm.basicInfo.budgetImgs,
        remarks: this.followForm.basicInfo.remark,
        // 客户需求
        house_price: this.followForm.requirements.housePrice,
        house_area: this.followForm.requirements.houseArea,
        like_style: this.followForm.requirements.style,
        occupancy_time_limit: this.followForm.requirements.moveInTime,
        productNeed: this.followForm.requirements.productNeed,
        customerFocus: this.followForm.requirements.customerFocus,
        customerLevel: this.followForm.requirements.customerLevel,
        decorationStatus: this.followForm.requirements.decorationStatus,
        deliveryTime: this.followForm.requirements.deliveryTime,
        decorationType: this.followForm.requirements.decorationType,
        // 门店信息
        storeSeller: this.followForm.storeInfo.guide,
        storeName: this.followForm.storeInfo.storeName,
        storeManager: this.followForm.storeInfo.storeManager
      }; // 调用后端API保存数据

      (0, _cust.editBaseInfo)(saveData).then(function (response) {
        // 保存客户需求数据（使用旧版本的保存接口）
        if (_this12.$refs.requirements && _this12.currentCustomer && _this12.currentCustomer.id) {
          var requirementsForm = _this12.$refs.requirements.form;
          requirementsForm.custId = _this12.currentCustomer.id; // 确保followId存在，否则使用null

          if (!requirementsForm.followId) {
            requirementsForm.followId = null;
          }

          var saveMethod = requirementsForm.id ? _followInfo.default.edit : _followInfo.default.add;
          saveMethod(requirementsForm).then(function (res) {}).catch(function (err) {
            console.error('保存客户需求失败:', err);
          });
        } // 显示保存成功提示


        _this12.$message.success('保存成功'); // 重新加载客户数据，确保页面显示最新信息


        if (_this12.currentCustomer && _this12.currentCustomer.id) {
          (0, _cmsWorkOrder.getCustInfo)(_this12.currentCustomer.id).then(function (response) {
            var latestCustomer = response;
            _this12.currentCustomer = _objectSpread({}, latestCustomer); // 重新初始化表单数据

            _this12.initFollowForm(latestCustomer); // 重新加载跟进记录


            _this12.loadFollowRecords(latestCustomer.id); // 重新加载主页面客户列表


            _this12.crud.toQuery(); // 刷新上传组件


            if (_this12.$refs.basicInfo) {
              _this12.$refs.basicInfo.init();
            }
          }).catch(function (error) {
            console.error('获取客户详情失败:', error);
          });
        } else {
          // 如果没有当前客户ID，也重新加载主页面客户列表
          _this12.crud.toQuery();
        }
      }).catch(function (error) {
        console.error('保存客户信息失败:', error);

        _this12.$message.error('保存失败，请重试');
      });
    },
    // 保存跟进信息
    handleFollowSave: function handleFollowSave(followData) {
      // 这里可以调用后端API保存跟进数据
      // 显示保存成功提示
      this.$message.success('跟进信息保存成功');
    },
    // 保存客户需求
    handleRequirementsSave: function handleRequirementsSave(requirementsData) {
      var _this13 = this;

      if (this.currentCustomer && this.currentCustomer.id) {
        requirementsData.custId = this.currentCustomer.id; // 确保followId存在，否则使用null

        if (!requirementsData.followId) {
          requirementsData.followId = null;
        } // 根据是否有ID决定调用新增还是编辑


        var saveMethod = requirementsData.id ? _followInfo.default.edit : _followInfo.default.add; // 调用后端API保存数据

        saveMethod(requirementsData).then(function (response) {
          // 显示保存成功提示
          _this13.$message.success('客户需求保存成功'); // 重新加载客户数据，确保页面显示最新信息


          (0, _cmsWorkOrder.getCustInfo)(_this13.currentCustomer.id).then(function (response) {
            if (response && response.code === 200 && response.data) {
              var latestCustomer = response.data;
              _this13.currentCustomer = _objectSpread({}, latestCustomer); // 重新初始化表单数据

              _this13.initFollowForm(latestCustomer); // 重新加载跟进记录


              _this13.loadFollowRecords(latestCustomer.id); // 重新加载主页面客户列表


              _this13.crud.toQuery();
            }
          }).catch(function (error) {
            console.error('获取客户详情失败:', error);
          });
        }).catch(function (error) {
          console.error('保存客户需求失败:', error);

          _this13.$message.error('保存失败，请重试');
        });
      }
    },
    // 初始化跟进表单
    initFollowForm: function initFollowForm(customer) {
      // 客户信息
      this.followForm.baseInfo = {
        name: customer.name || '',
        mobile: customer.mobile || '',
        msgFrom: customer.msgFrom || '',
        address: customer.address || '',
        custWechat: customer.custWechat || '',
        isDistributor: customer.isDistributor || '',
        inviter: customer.inviter || '',
        zxFrom: customer.zxFrom || ''
      }; // 客户基本情况

      var budgetImgs = [];

      if (customer.budgetImgs) {
        if (Array.isArray(customer.budgetImgs)) {
          budgetImgs = customer.budgetImgs;
        } else if (typeof customer.budgetImgs === 'string') {
          try {
            budgetImgs = JSON.parse(customer.budgetImgs);
          } catch (e) {
            console.error('解析 budgetImgs 失败:', e);
            budgetImgs = [];
          }
        }
      }

      var material = '';

      if (customer.material) {
        if (Array.isArray(customer.material)) {
          material = customer.material.join(', ');
        } else if (typeof customer.material === 'string') {
          material = customer.material;
        }
      }

      this.followForm.basicInfo = {
        focus: customer.styleFocus || '',
        needProduct1: customer.needProduct1 ? JSON.parse(customer.needProduct1) : [],
        needProduct2: customer.needProduct2 ? JSON.parse(customer.needProduct2) : [],
        needProduct3: customer.needProduct3 ? JSON.parse(customer.needProduct3) : [],
        budget: customer.budget || '',
        material: material,
        budgetImgs: budgetImgs,
        remark: customer.remarks || ''
      }; // 客户需求

      this.followForm.requirements = {
        housePrice: customer.house_price || '',
        houseArea: customer.house_area || '',
        style: customer.like_style || '',
        moveInTime: customer.occupancy_time_limit || '',
        productNeed: customer.productNeed || '',
        customerFocus: customer.styleFocus || '',
        customerLevel: customer.customerLevel || '',
        decorationStatus: customer.decorationStatus || '',
        deliveryTime: customer.deliveryTime || '',
        decorationType: customer.decorationType || ''
      }; // 门店信息

      this.followForm.storeInfo = {
        guide: customer.zxName || '',
        storeName: customer.zxDeptName || '',
        remarks: customer.remarks || '',
        storeManager: customer.zxManageName || ''
      };
    },
    // 加载跟进记录
    loadFollowRecords: function loadFollowRecords(customerId) {
      // 模拟从后端加载数据
      this.followRecords = [{
        id: 1,
        followTime: '2024-01-15 10:30:00',
        followUser: '张三',
        content: '客户对产品很感兴趣，约定下周再次沟通',
        followImgs: []
      }];
    },
    // 添加跟进记录
    addFollowRecord: function addFollowRecord() {
      if (!this.tempFollow.content) {
        this.$message.warning('请输入跟进内容');
        return;
      }

      var record = {
        id: Date.now(),
        followTime: this.tempFollow.followTime,
        followUser: this.tempFollow.followUser || '当前用户',
        content: this.tempFollow.content,
        followImgs: (0, _toConsumableArray2.default)(this.tempFollow.followImgs)
      };
      this.followRecords.unshift(record); // 清空表单

      this.tempFollow = {
        followTime: new Date().toISOString().slice(0, 19).replace('T', ' '),
        followUser: '',
        content: '',
        followImgs: []
      };
      this.$message.success('跟进记录添加成功');
    },
    // 删除跟进记录
    delFollowRecord: function delFollowRecord(index) {
      var _this14 = this;

      this.$confirm('确定要删除这条跟进记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this14.followRecords.splice(index, 1);

        _this14.$message.success('删除成功');
      }).catch(function () {});
    },
    // 跟进图片预览
    handleFollowImgPreview: function handleFollowImgPreview(file) {
      this.previewImgUrl = file.url;
      this.followImgDialogVisible = true;
    },
    // 跟进图片移除
    handleFollowImgRemove: function handleFollowImgRemove(file, fileList) {
      this.tempFollow.followImgs = fileList;
    },
    // 预算图预览
    handleBudgetImgPreview: function handleBudgetImgPreview(file) {
      this.previewImgUrl = file.url;
      this.followImgDialogVisible = true;
    },
    // 预算图移除
    handleBudgetImgRemove: function handleBudgetImgRemove(file, fileList) {
      this.followForm.basicInfo.budgetImgs = fileList;
    },
    // 预览跟进记录中的图片
    previewFollowImgs: function previewFollowImgs(imgs) {
      if (imgs && imgs.length > 0) {
        this.previewImgUrl = imgs[0].url;
        this.followImgDialogVisible = true;
      }
    },
    // 量房图片预览
    handleMeasureImgPreview: function handleMeasureImgPreview(file) {
      this.previewImgUrl = file.url;
      this.followImgDialogVisible = true;
    },
    // 量房图片移除
    handleMeasureImgRemove: function handleMeasureImgRemove(file, fileList) {
      this.followForm.measureInfo.measureImgs = fileList;
    },
    // 设计图片预览
    handleDesignImgPreview: function handleDesignImgPreview(file) {
      this.previewImgUrl = file.url;
      this.followImgDialogVisible = true;
    },
    // 设计图片移除
    handleDesignImgRemove: function handleDesignImgRemove(file, fileList) {
      this.followForm.designInfo.designImgs = fileList;
    },
    handleView: function handleView(row) {
      var _this15 = this;

      this.followDialogVisible = true;
      this.activeFollowTab = 'basicInfo'; // 先查询完整客户信息（包含followInfo等关联数据）

      (0, _cmsWorkOrder.getCustInfo)(row.id).then(function (response) {
        if (response && response.code === 200 && response.data) {
          var fullCustomer = response.data;
          _this15.currentCustomer = _objectSpread({}, fullCustomer);

          _this15.initFollowForm(fullCustomer);
        } else {
          _this15.currentCustomer = _objectSpread({}, row);

          _this15.initFollowForm(row);
        }
      }).catch(function () {
        _this15.currentCustomer = _objectSpread({}, row);

        _this15.initFollowForm(row);
      }); // 调用基本信息查询接口，加载基本信息数据

      this.$nextTick(function () {
        if (_this15.$refs.baseInfo) {
          _this15.$refs.baseInfo.init(row.id);
        }

        if (_this15.$refs.basicInfo) {
          _this15.$refs.basicInfo.init(row.id);
        }
      });
    },
    // 选择所在地区后，省市区自动填入"所在地区"字段
    handleRegionChange: function handleRegionChange(region) {
      if (region) {
        this.customerForm.district = region;
      }
    },
    // 详情地址自动填入"详细地址"字段
    handleDetailChange: function handleDetailChange(detail) {
      if (detail) {
        this.customerForm.address = detail;
      }
    },
    handleEdit: function handleEdit(row) {
      this.dialogTitle = '编辑客户';
      this.customerForm = _objectSpread({}, row); // 拆分地址到 address（兼容旧数据：若 address 含空格分隔的详细地址）

      var addr = this.customerForm.address || '';
      var spaceIdx = addr.indexOf(' ');

      if (spaceIdx > -1 && !this.customerForm.district) {
        this.customerForm.district = addr.substring(0, spaceIdx);
        this.customerForm.address = addr.substring(spaceIdx + 1).trim();
      }

      this.dialogVisible = true;
    },
    handleSave: function handleSave() {
      var _this16 = this;

      console.log("this.customerForm", this.customerForm); // 新增客户时不再拼接地区与详细地址，district 与 address 分开提交

      var submitData = _objectSpread({}, this.customerForm);

      this.$refs.customerForm.validate(function (valid) {
        console.log("valid", valid);

        if (valid) {
          // 确保把子组件同步到父级的 storeInto 写回到 customerForm 中，包含 planMeasureTime
          if (_this16.currentCustomer && _this16.currentCustomer.storeInto) {
            submitData.storeInto = _this16.currentCustomer.storeInto;
          }

          if (submitData.id) {
            _cust.default.edit(submitData).then(function (res) {
              _this16.crud.editSuccessNotify();

              var index = _this16.crud.data.findIndex(function (c) {
                return c.id === submitData.id;
              });

              if (index !== -1) {
                _this16.crud.data[index] = _objectSpread(_objectSpread({}, _this16.crud.data[index]), submitData);
              }
            });
          } else {
            _cust.default.add(submitData).then(function (res) {
              _this16.crud.addSuccessNotify();

              if (res.id) {
                var newCustomer = _objectSpread(_objectSpread({}, submitData), res);

                newCustomer.contracts = res.contracts || [];
                _this16.customerForm = newCustomer;

                _this16.crud.data.unshift(newCustomer);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    handleDialogClose: function handleDialogClose() {
      this.showContractTable = false;
      this.showContractForm = false;
    },
    // 折叠/展开方法
    toggleGroup: function toggleGroup(customerId) {
      var index = this.collapsedCustomers.indexOf(customerId);

      if (index === -1) {
        this.collapsedCustomers.push(customerId);
      } else {
        this.collapsedCustomers.splice(index, 1); // 当客户展开时，加载合同数据
        // 不再需要加载合同数据，因为现在直接使用 customer.contracts
      }
    },
    // 行点击事件
    handleRowClick: function handleRowClick(row) {
      // 使用表格的toggleRowExpansion方法切换展开/折叠状态
      this.$refs.customerTable.toggleRowExpansion(row);
    },
    // 树节点点击事件
    handleTreeNodeClick: function handleTreeNodeClick(data) {// 点击单元格时切换子节点显示/隐藏
    },
    // 打开配置弹窗
    openConfigDialog: function openConfigDialog() {
      this.originalHeaderConfig = this.tableHeader.map(function (col, index) {
        return {
          key: col.key,
          visible: col.visible,
          sort: index
        };
      });
      this.configDialogVisible = true;
    },
    // 保存表头配置
    saveHeaderConfig: function () {
      var _saveHeaderConfig = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this17 = this;

        var config, dictData, updatePromises;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = this.tableHeader.map(function (col, index) {
                  return {
                    key: col.key,
                    visible: col.visible,
                    sort: index
                  };
                });
                localStorage.setItem('customerHeaderConfig', JSON.stringify(config));
                dictData = this.dict.customer_list_display_fields;
                updatePromises = [];
                config.forEach(function (item, index) {
                  var originalItem = _this17.originalHeaderConfig.find(function (o) {
                    return o.key === item.key;
                  });

                  if (originalItem && (originalItem.visible !== item.visible || originalItem.sort !== index)) {
                    var dictItem = dictData.find(function (d) {
                      return d.value === item.key;
                    });

                    if (dictItem && dictItem.id) {
                      updatePromises.push((0, _dictDetail.edit)({
                        id: dictItem.id,
                        dict: {
                          id: dictItem.dict.id
                        },
                        value: dictItem.value,
                        label: dictItem.label,
                        unit: item.visible,
                        dictSort: index
                      }));
                    }
                  }
                });

                if (!(updatePromises.length > 0)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return Promise.all(updatePromises);

              case 9:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this17.crud.toQuery();
                });
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                console.error('保存字典配置失败:', _context.t0);
                this.$message.warning('本地保存成功，但服务器保存失败');
                this.$nextTick(function () {
                  _this17.crud.toQuery();
                });

              case 18:
                _context.next = 22;
                break;

              case 20:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this17.crud.toQuery();
                });

              case 22:
                this.configDialogVisible = false;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 13]]);
      }));

      function saveHeaderConfig() {
        return _saveHeaderConfig.apply(this, arguments);
      }

      return saveHeaderConfig;
    }(),
    // 重置表头配置
    resetHeaderConfig: function resetHeaderConfig() {
      var fields = this.dict.customer_list_display_fields.filter(function (item) {
        return item.value && item.label;
      });
      var newTableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      newTableHeader.sort(function (a, b) {
        return a.sort - b.sort;
      });
      this.tableHeader = newTableHeader;
    },
    // 判断是否为特殊列
    isSpecialColumn: function isSpecialColumn(key) {
      return key === 'name' || key === 'custStatus';
    },
    // 获取列样式类
    getColumnClass: function getColumnClass(key) {
      if (key === 'name') return 'cursor-pointer';
      if (key === 'custStatus') return 'status-badge';
      return 'value';
    },
    // 获取列点击事件
    getColumnClickHandler: function getColumnClickHandler(key, customer) {
      var _this18 = this;

      if (key === 'name') {
        return function () {
          return _this18.handleView(customer);
        };
      }

      return null;
    },
    // 处理列点击事件
    handleColumnClick: function handleColumnClick(key, row, event) {
      var handler = this.getColumnClickHandler(key, row);

      if (handler) {
        event.stopPropagation();
        handler();
      }
    },
    openOrderRateDialog: function openOrderRateDialog() {
      this.orderRateDialogVisible = true;
    },
    // 获取列值
    getColumnValue: function getColumnValue(key, customer) {
      if (!customer) return '-';
      if (key === 'custStatus') return customer.custStatus || '未知';
      if (key === 'contractCount') return "".concat(customer.contracts && customer.contracts.length || 0, " \u7B14");

      if (key.includes('.')) {
        var keys = key.split('.');
        var value = customer;

        var _iterator2 = _createForOfIteratorHelper(keys),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var k = _step2.value;

            if (value && (0, _typeof2.default)(value) === 'object') {
              value = value[k];
            } else {
              return '-';
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return value || '-';
      }

      return customer[key] || '-';
    },
    // 获取字符串显示宽度（中文、英文、数字分别计算）
    getStrWidth: function getStrWidth(str) {
      var width = 0;

      var _iterator3 = _createForOfIteratorHelper(String(str)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var char = _step3.value;

          if (/[\u4e00-\u9fa5]/.test(char)) {
            width += 24;
          } else if (/[0-9]/.test(char)) {
            width += 10;
          } else {
            width += 10;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return width;
    },
    // 获取列宽度 - 占满100%，超出不缩放
    getColumnWidth: function getColumnWidth(key) {
      var _this19 = this;

      if (!this.crud.data || this.crud.data.length === 0) {
        return 140;
      }

      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      var headerWidth = this.getStrWidth(col ? col.label : key);
      var values = this.crud.data.map(function (row) {
        return _this19.getColumnValue(key, row) || '';
      });
      var dataWidth = Math.max.apply(Math, (0, _toConsumableArray2.default)(values.map(function (v) {
        return _this19.getStrWidth(v);
      })));
      var maxWidth = Math.max(headerWidth, dataWidth);
      var minWidth = 80;
      return Math.max(maxWidth + 20, minWidth);
    },
    // 获取列可见性
    isColumnVisible: function isColumnVisible(key) {
      var col = this.tableHeader.find(function (col) {
        return col.key === key;
      });
      return col ? col.visible : true;
    },
    // 切换列可见性
    toggleColumnVisible: function toggleColumnVisible(key) {
      var col = this.tableHeader.find(function (col) {
        return col.key === key;
      });

      if (col) {
        col.visible = !col.visible;
      }
    },
    // 全部左移（隐藏所有列）
    moveAllToLeft: function moveAllToLeft() {
      this.tableHeader.forEach(function (col) {
        col.visible = false;
      });
    },
    // 全部右移（显示所有列）
    moveAllToRight: function moveAllToRight() {
      this.tableHeader.forEach(function (col) {
        col.visible = true;
      });
    },
    // 列排序移动
    moveColumn: function moveColumn(key, direction) {
      var visibleCols = this.tableHeader.filter(function (col) {
        return col.visible;
      });
      var currentIndex = visibleCols.findIndex(function (col) {
        return col.key === key;
      });
      if (currentIndex === -1) return;
      var newIndex = currentIndex + direction;

      if (newIndex < 0 || newIndex >= visibleCols.length) {
        return;
      }

      var currentCol = visibleCols[currentIndex];
      var targetCol = visibleCols[newIndex];
      var currentColRealIndex = this.tableHeader.findIndex(function (col) {
        return col.key === currentCol.key;
      });
      var targetColRealIndex = this.tableHeader.findIndex(function (col) {
        return col.key === targetCol.key;
      });
      var temp = this.tableHeader[currentColRealIndex];
      this.tableHeader.splice(currentColRealIndex, 1, this.tableHeader[targetColRealIndex]);
      this.tableHeader.splice(targetColRealIndex, 1, temp);
    },
    expandAll: function expandAll() {
      var _this20 = this;

      this.collapsedCustomers = [];
      this.allExpanded = true;
      this.$nextTick(function () {
        _this20.crud.data.forEach(function (row) {
          _this20.$refs.customerTable.toggleRowExpansion(row, true);
        });
      });
    },
    collapseAll: function collapseAll() {
      var _this21 = this;

      this.collapsedCustomers = this.crud.data.map(function (customer) {
        return customer.id;
      });
      this.allExpanded = false;
      this.$nextTick(function () {
        _this21.crud.data.forEach(function (row) {
          _this21.$refs.customerTable.toggleRowExpansion(row, false);
        });
      });
    },
    toggleExpandAll: function toggleExpandAll() {
      if (this.allExpanded) {
        this.collapseAll();
      } else {
        this.expandAll();
      }
    },
    // 状态相关方法
    getCustomerStatusTag: function getCustomerStatusTag(status) {
      var statusMap = {
        following: '跟进',
        noOrder: '未签单',
        ordered: '已下单',
        completed: '已完成',
        afterSales: '售后'
      };
      return statusMap[status] || '未知';
    },
    getStatusClass: function getStatusClass(status) {
      var classMap = {
        '已下单': 'status-ordered',
        '待跟进': 'status-following',
        '跟进中': 'status-following-in',
        '已签单': 'status-done',
        '未知': 'status-unknown'
      };
      return classMap[status] || 'status-unknown';
    },
    getStatusText: function getStatusText(status) {
      var textMap = {
        '跟进中': '跟进中',
        '未下单': '未下单',
        '已下单': '已下单',
        '已完成': '已完成',
        '售后中': '售后中'
      };
      return textMap[status] ? textMap[status] : '未知';
    },
    getContractStatusClass: function getContractStatusClass(status) {
      var classMap = {
        pending: 'o-status-unknown',
        processing: 'o-status-pending',
        completed: 'o-status-done'
      };
      return classMap[status] || 'o-status-unknown';
    },
    getContractStatusText: function getContractStatusText(status) {
      var textMap = {
        pending: '待处理',
        processing: '处理中',
        completed: '已完成'
      };
      return textMap[status] || '未知';
    },
    // 合同管理方法
    handleAddContract: function handleAddContract(customer) {
      var _this22 = this;

      this.editingContractId = null;
      this.contractForm = {
        id: '',
        contractNo: '',
        dealerCode: '',
        dealer: '',
        dealerShopCode: '',
        dealerShopName: '',
        type: '',
        unmeasured: '否',
        customerName: customer.name || '',
        customerPhone: customer.mobile || '',
        contractAmount: 0,
        budgetAmount: 0,
        address: customer.address || '',
        images: [],
        attachments: [],
        custId: customer.id,
        file: ''
      };
      this.getDictData();
      this.loadDealerList();
      this.loadDealerShopList();
      this.showContractEditDialog = true; // 刷新图片上传组件

      this.$nextTick(function () {
        if (_this22.$refs.contractImgUpload) {
          _this22.$refs.contractImgUpload.clearImgs();
        } // 刷新附件上传组件


        if (_this22.$refs.contractFileUpload) {
          _this22.$refs.contractFileUpload.clearFiles(); // 如果有已上传的附件，填充到文件列表中


          if (_this22.contractForm.attachments && _this22.contractForm.attachments.length > 0) {
            var fileList = [];
            var filePaths = [];

            _this22.contractForm.attachments.forEach(function (attachment) {
              var fileName = attachment.realName;
              var alias = attachment.alias || ''; // 获取全局的文件域名前缀

              var filePreviewPrefix = _this22.$store.getters.filePreviewPrefix || '';
              var fileUrl = attachment.url || filePreviewPrefix + attachment.realName;
              fileList.push({
                name: alias || fileName,
                url: fileUrl,
                response: {
                  realName: fileName,
                  url: fileUrl,
                  alias: alias
                }
              });
              filePaths.push(JSON.stringify({
                realName: fileName,
                url: fileUrl,
                alias: alias
              }));
            });

            _this22.$refs.contractFileUpload.fileList = fileList;
            _this22.$refs.contractFileUpload.filePaths = filePaths;
          }
        }
      });
    },
    getDictData: function getDictData() {// 字典数据已由系统自动加载到this.dict中
      // 这里可以添加额外的字典处理逻辑（如果需要）
    },
    loadDealerList: function loadDealerList() {
      var _this23 = this;

      (0, _cmsWorkOrder.queryDealer)().then(function (res) {
        if (res.code === 200) {
          _this23.dealerList = res.data || [];
        }
      }).catch(function () {
        _this23.dealerList = [];
      });
    },
    handleDealerChange: function handleDealerChange(val) {
      var dealer = this.dealerList.find(function (item) {
        return (item.code || item.name) === val;
      });
      this.contractForm.dealer = dealer ? dealer.name : ''; // 清空门店选择

      this.contractForm.dealerShopCode = '';
      this.contractForm.dealerShopName = ''; // 根据经销商重新加载门店列表

      if (val) {
        this.loadDealerShopByDealer(val);
      } else {
        this.loadDealerShopList();
      }
    },
    // 根据经销商编码加载门店列表
    loadDealerShopByDealer: function loadDealerShopByDealer(dealerCode) {
      var _this24 = this;

      (0, _cmsWorkOrder.queryDealerShopByDealer)(dealerCode).then(function (res) {
        if (res.code === 200) {
          _this24.dealerShopList = res.data || [];
        } else {
          _this24.dealerShopList = [];
        }
      }).catch(function () {
        _this24.dealerShopList = [];
      });
    },
    loadDealerShopList: function loadDealerShopList() {
      var _this25 = this;

      (0, _cmsWorkOrder.queryDealerShop)().then(function (res) {
        if (res.code === 200) {
          _this25.dealerShopList = res.data || [];
        }
      });
    },
    handleDealerShopChange: function handleDealerShopChange(val) {
      var shop = this.dealerShopList.find(function (item) {
        return item.shopNo === val;
      });
      this.contractForm.dealerShopName = shop ? shop.shopName : '';
    },
    handleUnmeasuredChange: function handleUnmeasuredChange(val) {},
    handleContractNoChange: function handleContractNoChange(val) {// 只处理合同号变化，不联动修改是否测未定
    },
    handleEditContract: function handleEditContract(contract) {
      var _this26 = this;

      this.editingContractId = contract.id;
      this.loadDealerList(); // 编辑时若合同已关联经销商，只加载该经销商下的门店；否则加载全量门店

      if (contract.dealerCode) {
        this.loadDealerShopByDealer(contract.dealerCode);
      } else {
        this.loadDealerShopList();
      } // 初始化合同表单


      this.contractForm = _objectSpread(_objectSpread({}, contract), {}, {
        type: contract.type || '',
        orderLevel: contract.orderLevel || '',
        customerName: contract.customerName || '',
        customerPhone: contract.customerPhone || '',
        contractNo: contract.contractNo || '',
        dealerShopCode: contract.dealerShopCode || contract.shopNo || '',
        dealerShopName: contract.dealerShopName || contract.shopName || '',
        dealerCode: contract.dealerCode || '',
        dealer: contract.dealer || '',
        contractAmount: contract.contractAmount || contract.amount || 0,
        images: [],
        budgetAmount: contract.budgetAmount || 0,
        attachments: contract.attachments || [],
        address: contract.address || '',
        contractImgs: contract.contractImgs || [],
        file: contract.file || ''
      }); // 从 contractImgs 中解析图片数据

      if (contract.contractImgs) {
        try {
          var parsedImages = JSON.parse(contract.contractImgs);

          if (Array.isArray(parsedImages)) {
            this.contractForm.images = parsedImages;
          }
        } catch (e) {}
      } // 从 file 字段中解析附件数据


      if (contract.file) {
        try {
          var parsedAttachments = JSON.parse(contract.file);

          if (Array.isArray(parsedAttachments)) {
            this.contractForm.attachments = parsedAttachments;
          }
        } catch (e) {
          // 兼容旧格式：file 为单个URL字符串
          if (typeof contract.file === 'string' && contract.file.startsWith('http')) {
            var fileName = contract.file.split('/').pop();
            this.contractForm.attachments = [{
              realName: fileName,
              url: contract.file
            }];
          }
        }
      } // 如果有客户ID，从客户信息中获取客户姓名、客户电话和客户地址


      if (contract.custId) {
        // 从 crud.data 中查找客户信息
        var customer = this.crud.data.find(function (c) {
          return c.id === contract.custId;
        });

        if (customer) {
          this.contractForm.customerName = contract.contactPerson || customer.name || '';
          this.contractForm.customerPhone = contract.contactNumber || customer.mobile || '';
          this.contractForm.address = contract.contactAddress || customer.address || '';
        } else {
          // 如果在 crud.data 中找不到，尝试从当前客户中获取
          if (this.currentCustomer && this.currentCustomer.id === contract.custId) {
            this.contractForm.customerName = contract.contactPerson || this.currentCustomer.name || '';
            this.contractForm.customerPhone = contract.contactNumber || this.currentCustomer.mobile || '';
            this.contractForm.address = contract.contactAddress || this.currentCustomer.address || '';
          }
        }
      } // 检查是否在客户编辑弹窗中


      if (this.dialogVisible) {
        this.showContractForm = true;
      } else {
        // 在主页面点击编辑，显示主页面合同编辑弹窗
        this.showContractEditDialog = true;
      } // 刷新图片上传组件


      this.$nextTick(function () {
        if (_this26.$refs.contractImgUpload) {
          _this26.$refs.contractImgUpload.clearImgs();
        } // 刷新附件上传组件，不加载已有的附件


        if (_this26.$refs.contractFileUpload) {
          _this26.$refs.contractFileUpload.clearFiles();
        }
      });
    },
    // 文件上传相关方法
    handlePreview: function handlePreview(file) {},
    handleRemove: function handleRemove(file, fileList) {
      var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'images';
      this.contractForm[field] = fileList;
    },
    // 合同图片预览
    handleContractImgPreview: function handleContractImgPreview(file) {
      // 确保 file 有 url 属性
      if (file.url) {
        this.previewImgUrl = file.url;
      } else if (file.realName) {
        // 如果只有 realName，构建图片 URL
        this.previewImgUrl = "/api/file/download?fileName=".concat(encodeURIComponent(file.realName));
      }

      this.followImgDialogVisible = true;
    },
    // 合同文件下载
    handleContractFilePreview: function handleContractFilePreview(file) {
      // 创建一个临时的a标签用于下载
      var link = document.createElement('a');
      link.href = file.url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 合同图片移除
    handleContractImgRemove: function handleContractImgRemove(file, fileList) {
      var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'images';
      this.contractForm[field] = fileList;
    },
    // 生成合同图片URL
    getContractImgUrl: function getContractImgUrl(img) {
      var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';

      if (img.url) {
        return img.url;
      } else if (img.realName) {
        return imgPreviewPrefix + img.realName;
      }

      return '';
    },
    // 生成合同图片URL列表
    getContractImgUrls: function getContractImgUrls(imgs) {
      var _this27 = this;

      if (!imgs || !Array.isArray(imgs)) {
        return [];
      }

      return imgs.map(function (img) {
        return _this27.getContractImgUrl(img);
      });
    },
    // 删除指定索引的合同图片
    delContractImgIndex: function delContractImgIndex(index) {
      if (this.contractForm.images && Array.isArray(this.contractForm.images)) {
        this.contractForm.images.splice(index, 1);
      }
    },
    // 生成合同编号（兼容旧调用）
    getContractNumber: function getContractNumber(data) {
      this.generateContractNo();
    },
    // 生成合同号
    generateContractNo: function generateContractNo() {
      var _this28 = this;

      var code = this.contractForm.dealerShopCode;

      if (!code) {
        this.$message.warning('请先选择门店');
        return;
      }

      (0, _request.default)({
        url: 'api/contract/autoGenerateContractNoByShopCode',
        method: 'get',
        params: {
          code: code
        }
      }).then(function (res) {
        if (res.code === 200) {
          _this28.contractForm.contractNo = res.data;
        } else {
          _this28.$message.error(res.msg || '生成合同号失败');
        }
      }).catch(function (err) {
        console.error('生成合同号失败:', err);

        _this28.$message.error('生成合同号失败');
      });
    },
    // 下单方法
    handleCreateOrder: function handleCreateOrder(contract) {
      // 跳转到订单创建页面，并传递合同信息
      this.$router.push({
        path: '/orders/create',
        query: {
          contractId: contract.id,
          contractNo: contract.contractNo,
          contractAmount: contract.contractAmount
        }
      });
    },
    handleDeleteContract: function handleDeleteContract(contractId) {
      var _this29 = this;

      this.$confirm('确定要删除这个合同吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _cmsWorkOrder.delContract)([contractId]).then(function (response) {
          // 检查响应是否成功
          if (response && response.code === 200) {
            // 从本地数据中移除删除的合同
            if (_this29.customerForm.contracts) {
              _this29.customerForm.contracts = _this29.customerForm.contracts.filter(function (c) {
                return c.id !== contractId;
              });
            } // 同时从 crud.data 中移除


            _this29.crud.data.forEach(function (customer) {
              if (customer.contracts) {
                customer.contracts = customer.contracts.filter(function (c) {
                  return c.id !== contractId;
                });
              }
            }); // 不再需要从 contracts 对象中移除，因为现在直接使用 customer.contracts


            _this29.$message.success('删除成功');
          } else {
            _this29.$message.error('删除失败：' + (response.msg || '未知错误'));
          }
        }).catch(function (error) {
          console.error('删除合同失败:', error);

          _this29.$message.error('删除失败，请重试');
        });
      }).catch(function () {// 取消删除
      });
    },
    handleArchiveContract: function handleArchiveContract(contractId) {
      var _this30 = this;

      this.$confirm('确定要归档这个合同吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(function () {
        (0, _cmsWorkOrder.archiveContract)(contractId).then(function (response) {
          if (response && response.code === 200) {
            _this30.$message.success('归档成功');

            _this30.crud.toQuery();
          } else {
            _this30.$message.error('归档失败：' + (response.msg || '未知错误'));
          }
        }).catch(function (error) {
          console.error('归档合同失败:', error);

          _this30.$message.error('归档失败，请重试');
        });
      }).catch(function () {});
    },
    handleUnarchiveContract: function handleUnarchiveContract(contractId) {
      var _this31 = this;

      this.$confirm('确定要取消归档这个合同吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(function () {
        (0, _cmsWorkOrder.unArchiveContract)(contractId).then(function (response) {
          if (response && response.code === 200) {
            _this31.$message.success('取消归档成功');

            _this31.crud.toQuery();
          } else {
            _this31.$message.error('取消归档失败：' + (response.msg || '未知错误'));
          }
        }).catch(function (error) {
          console.error('取消归档合同失败:', error);

          _this31.$message.error('取消归档失败，请重试');
        });
      }).catch(function () {});
    },
    handleAuditContract: function handleAuditContract(contractId) {
      var _this32 = this;

      this.$confirm('确定要更新审计状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(function () {
        (0, _cmsWorkOrder.auditContract)(contractId).then(function (response) {
          if (response && response.code === 200) {
            _this32.$message.success('操作成功');

            _this32.crud.toQuery();
          } else {
            _this32.$message.error('操作失败：' + (response.msg || '未知错误'));
          }
        }).catch(function (error) {
          console.error('审计合同失败:', error);

          _this32.$message.error('操作失败，请重试');
        });
      }).catch(function () {});
    },
    handleUnAuditContract: function handleUnAuditContract(contractId) {
      var _this33 = this;

      this.$confirm('确定要取消审计吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(function () {
        (0, _cmsWorkOrder.unAuditContract)(contractId).then(function (response) {
          if (response && response.code === 200) {
            _this33.$message.success('取消审计成功');

            _this33.crud.toQuery();
          } else {
            _this33.$message.error('取消审计失败：' + (response.msg || '未知错误'));
          }
        }).catch(function (error) {
          console.error('取消审计合同失败:', error);

          _this33.$message.error('取消审计失败，请重试');
        });
      }).catch(function () {});
    },
    handleFollowContract: function handleFollowContract(contract) {
      // 找到包含该合同的客户，获取客户信息
      var customer = this.crud.data.find(function (cust) {
        return cust.contracts.some(function (c) {
          return c.id === contract.id;
        });
      }); // 合并客户信息到合同数据中

      if (customer) {
        this.currentCustomer = customer;
        this.currentContract = _objectSpread(_objectSpread({}, contract), {}, {
          customerName: customer.name,
          customerPhone: customer.mobile,
          address: customer.address
        }); // 打开合同详情弹窗

        this.showContractViewDialog = true; // 跳转到跟进信息标签页

        this.activeContractTab = 'follow';
      }
    },
    handleViewContract: function handleViewContract(contract) {
      // 找到包含该合同的客户，获取客户信息
      var customer = this.crud.data.find(function (cust) {
        return cust.contracts.some(function (c) {
          return c.id === contract.id;
        });
      }); // 合并客户信息到合同数据中

      if (customer) {
        this.currentCustomer = customer;
        this.currentContract = _objectSpread(_objectSpread({}, contract), {}, {
          customerName: customer.name,
          customerPhone: customer.mobile,
          address: customer.address
        });
      } else {
        this.currentContract = contract;
      } // 处理合同图片


      try {
        var imgs = JSON.parse(contract.contractImgs || '[]'); // 获取全局的文件域名前缀

        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        this.contractViewImages = imgs.map(function (img) {
          return {
            url: "".concat(imgPreviewPrefix).concat(img.realName),
            name: img.realName
          };
        });
      } catch (e) {
        this.contractViewImages = [];
      } // 处理合同附件


      try {
        var files = JSON.parse(contract.file || '[]'); // 获取全局的文件域名前缀

        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        this.contractViewFiles = files.map(function (file) {
          return {
            url: "".concat(filePreviewPrefix).concat(file.realName),
            name: file.alias || file.realName
          };
        });
      } catch (e) {
        this.contractViewFiles = [];
      } // 设置默认导航到设计信息


      this.activeContractTab = 'design'; // 打开合同查看弹窗

      this.showContractViewDialog = true;
    },
    // 预览图片
    previewImage: function previewImage(url) {
      this.previewImageUrl = url;
      this.previewImageVisible = true;
    },
    updateSalesman: function updateSalesman(contractId, salesmanId) {
      // 更新合同的销售人员
      this.crud.data.forEach(function (customer) {
        customer.contracts.forEach(function (contract) {
          if (contract.id === contractId) {
            contract.salesmanId = salesmanId;
          }
        });
      });
    },
    showLocation: function showLocation(address) {
      // 显示地址定位
      this.$message.info("\u5B9A\u4F4D\u5730\u5740\uFF1A".concat(address));
    },
    cancelContractForm: function cancelContractForm() {
      this.showContractForm = false;
      this.editingContractId = null;
    },
    uploadContractImgs: function uploadContractImgs(imgs) {
      this.$message.success('图片上传成功');
    },
    delContractImg: function delContractImg(imgs) {},
    uploadContractFiles: function uploadContractFiles(files) {
      this.$message.success('附件上传成功');
    },
    delContractFile: function delContractFile(files) {}
  }, (0, _defineProperty2.default)(_methods, "delContractImgIndex", function delContractImgIndex(index) {
    if (this.contractForm.images && this.contractForm.images.length > index) {
      this.contractForm.images.splice(index, 1);
    }
  }), (0, _defineProperty2.default)(_methods, "delContractImgByIndex", function delContractImgByIndex(index) {
    if (this.contractForm.contractImgs) {
      try {
        // 从 contractImgs 字段中获取图片数据
        var imgs = JSON.parse(this.contractForm.contractImgs);

        if (Array.isArray(imgs) && imgs.length > index) {
          // 从数组中删除指定索引的图片
          imgs.splice(index, 1); // 更新 contractImgs 字段

          this.contractForm.contractImgs = JSON.stringify(imgs);
        }
      } catch (e) {
        console.error('解析图片数据失败:', e);
      }
    }
  }), (0, _defineProperty2.default)(_methods, "delContractFileByIndex", function delContractFileByIndex(index) {
    if (this.contractForm.file) {
      try {
        // 从 file 字段中获取附件数据
        var files = JSON.parse(this.contractForm.file);

        if (Array.isArray(files) && files.length > index) {
          // 从数组中删除指定索引的附件
          files.splice(index, 1); // 更新 file 字段

          this.contractForm.file = JSON.stringify(files);
        }
      } catch (e) {
        console.error('解析附件数据失败:', e);
      }
    }
  }), (0, _defineProperty2.default)(_methods, "safeJsonParse", function safeJsonParse(jsonString) {
    try {
      return typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString;
    } catch (e) {
      console.error('JSON解析失败:', e);
      return [];
    }
  }), (0, _defineProperty2.default)(_methods, "contractImgUrl", function contractImgUrl(imgs) {
    var _this34 = this;

    imgs = this.safeJsonParse(imgs);
    var imgUrls = [];

    if (imgs && Array.isArray(imgs)) {
      imgs.forEach(function (img) {
        try {
          img = img.type == undefined ? JSON.parse(img) : img;
          imgUrls.push(_this34.$store.getters.imgPreviewPrefix + img.realName);
        } catch (e) {
          console.error('解析图片数据失败:', e);
        }
      });
    }

    return imgUrls;
  }), (0, _defineProperty2.default)(_methods, "contractFileUrl", function contractFileUrl(files) {
    var _this35 = this;

    files = this.safeJsonParse(files);
    var fileUrls = [];

    if (files && Array.isArray(files)) {
      files.forEach(function (file) {
        try {
          file = file.type == undefined ? JSON.parse(file) : file;
          fileUrls.push(file.url || _this35.$store.getters.filePreviewPrefix + file.realName);
        } catch (e) {
          console.error('解析附件数据失败:', e);
        }
      });
    }

    return fileUrls;
  }), (0, _defineProperty2.default)(_methods, "downloadFile", function downloadFile(url, filename) {
    try {
      // 通过 fetch + blob 下载，避免跨域 OSS 链接导致 a.download 不生效
      if (url && (url.indexOf(location.origin) === 0 || url.startsWith('data:') || url.startsWith('blob:'))) {
        var link = document.createElement('a');
        link.href = url;
        link.download = filename || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (url) {
        fetch(url, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = blobUrl;
          link.download = filename || 'download';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          window.open(url, '_blank');
        });
      }
    } catch (e) {
      console.error('下载文件失败:', e);
      this.$message.error('下载失败，请重试');
    }
  }), (0, _defineProperty2.default)(_methods, "formatDate", function formatDate(dateString) {
    if (!dateString) return '-';
    var date = new Date(dateString);
    return date.toLocaleString('zh-CN');
  }), (0, _defineProperty2.default)(_methods, "cancelContractEditDialog", function cancelContractEditDialog() {
    this.showContractEditDialog = false;
    this.editingContractId = null; // 清空合同图片上传组件

    if (this.$refs.contractImgUpload) {
      this.$refs.contractImgUpload.clearImgs();
    } // 清空合同附件上传组件


    if (this.$refs.contractFileUpload) {
      this.$refs.contractFileUpload.clearFiles();
    } // 重置合同表单


    this.contractForm = {
      id: '',
      contractNo: '',
      dealerCode: '',
      dealer: '',
      dealerShopCode: '',
      dealerShopName: '',
      type: '',
      unmeasured: '否',
      customerName: '',
      customerPhone: '',
      contractAmount: 0,
      budgetAmount: 0,
      address: '',
      images: [],
      attachments: [],
      custId: '',
      file: ''
    };
  }), (0, _defineProperty2.default)(_methods, "saveContractFromDialog", function saveContractFromDialog() {
    var _this36 = this;

    this.$refs.contractForm.validate(function (valid) {
      if (valid) {
        var _contractData;

        // 判断是否存在客户ID
        var custId = _this36.contractForm.custId || _this36.customerForm.id;

        if (!custId) {
          _this36.$message.warning('请先保存客户信息，再添加合同');

          return;
        } // 合并上传组件中的文件与现有的文件，参考跟进记录的实现


        var allImages = [];
        var allAttachments = []; // 首先添加已保存的文件（从contractForm中获取）

        if (_this36.contractForm.contractImgs) {
          try {
            var existingImages = typeof _this36.contractForm.contractImgs === 'string' ? JSON.parse(_this36.contractForm.contractImgs) : _this36.contractForm.contractImgs;

            if (Array.isArray(existingImages)) {
              allImages = (0, _toConsumableArray2.default)(existingImages);
            }
          } catch (e) {
            console.error('解析已保存的图片数据失败:', e);
          }
        }

        if (_this36.contractForm.file) {
          try {
            var existingFiles = typeof _this36.contractForm.file === 'string' ? JSON.parse(_this36.contractForm.file) : _this36.contractForm.file;

            if (Array.isArray(existingFiles)) {
              allAttachments = (0, _toConsumableArray2.default)(existingFiles);
            } else {
              // 非数组格式，尝试作为单个URL处理
              console.warn('附件数据非数组格式，按单个URL处理');
            }
          } catch (e) {
            console.error('解析已保存的附件数据失败，按单个URL处理:', e); // 兼容旧数据：file 字段可能是单个URL字符串，包装为标准格式

            if (typeof _this36.contractForm.file === 'string' && _this36.contractForm.file.startsWith('http')) {
              var fileName = _this36.contractForm.file.split('/').pop();

              allAttachments = [{
                realName: fileName,
                url: _this36.contractForm.file
              }];
            }
          }
        } // 然后添加新上传的文件


        if (_this36.$refs.contractImgUpload && _this36.$refs.contractImgUpload.filePaths) {
          _this36.$refs.contractImgUpload.filePaths.forEach(function (img) {
            try {
              var imgObj = JSON.parse(img); // 检查是否已存在相同的图片，避免重复添加

              var isDuplicate = allImages.some(function (existingImg) {
                var existingRealName = typeof existingImg === 'string' ? JSON.parse(existingImg).realName : existingImg.realName;
                return existingRealName === imgObj.realName;
              });

              if (!isDuplicate) {
                allImages.push(imgObj);
              }
            } catch (e) {
              console.error('解析图片数据失败:', e);
            }
          });
        }

        if (_this36.$refs.contractFileUpload) {
          var newFiles = _this36.$refs.contractFileUpload.getUploadedFiles();

          newFiles.forEach(function (file) {
            var isDuplicate = allAttachments.some(function (existingFile) {
              var existingRealName = typeof existingFile === 'string' ? JSON.parse(existingFile).realName : existingFile.realName;
              return existingRealName === file.realName;
            });

            if (!isDuplicate) {
              allAttachments.push(file);
            }
          });
        } // 准备请求参数


        var contractData = (_contractData = {
          id: _this36.editingContractId,
          amount: _this36.contractForm.contractAmount || 0,
          contractTime: _this36.contractForm.contractTime,
          custId: _this36.contractForm.custId || _this36.customerForm.id,
          type: _this36.contractForm.type,
          contractNo: _this36.contractForm.contractNo,
          dealerShopCode: _this36.contractForm.dealerShopCode || '',
          dealerShopName: _this36.contractForm.dealerShopName || '',
          dealerCode: _this36.contractForm.dealerCode || '',
          dealer: _this36.contractForm.dealer || '',
          unmeasured: _this36.contractForm.unmeasured || '',
          // 选填参数
          amountReceived: _this36.contractForm.amountReceived || 0,
          approvalInfo: _this36.contractForm.approvalInfo || '',
          approveDatetime: _this36.contractForm.approveDatetime || '',
          approveUser: _this36.contractForm.approveUser || '',
          contractdetailImgs: _this36.contractForm.contractdetailImgs || '',
          deliveryAmount: _this36.contractForm.deliveryAmount || 0,
          budgetAmount: _this36.contractForm.budgetAmount || 0,
          remark: _this36.contractForm.remark || '',
          approveRemark: _this36.contractForm.approveRemark || '',
          contractImgs: allImages && allImages.length > 0 ? JSON.stringify(allImages.map(function (img) {
            return {
              realName: img.realName,
              type: '图片',
              url: img.url
            };
          })) : '',
          file: allAttachments && allAttachments.length > 0 ? JSON.stringify(allAttachments.map(function (file, index) {
            return {
              realName: file.realName,
              type: '附件',
              url: file.url,
              alias: _this36.contractForm.contractNo + '_' + (index + 1) + '_' + (file.localName || file.realName)
            };
          })) : '',
          guideUserName: _this36.contractForm.guideUserName || '',
          guideNickName: _this36.contractForm.guideNickName || '',
          contractStatusEnumeration: _this36.contractForm.contractStatusEnumeration || '',
          positioning: _this36.contractForm.positioning || '',
          designerUserName: _this36.contractForm.designerUserName || '',
          designerNickName: _this36.contractForm.designerNickName || '',
          contactPersonUserName: _this36.contractForm.contactPersonUserName || '',
          contactPersonNickName: _this36.contractForm.contactPersonNickName || '',
          orderClerkUserName: _this36.contractForm.orderClerkUserName || '',
          orderClerkNickName: _this36.contractForm.orderClerkNickName || '',
          measureTime: _this36.contractForm.measureTime || '',
          recoveryTime: _this36.contractForm.recoveryTime || '',
          confirmPlanTime: _this36.contractForm.confirmPlanTime || ''
        }, (0, _defineProperty2.default)(_contractData, "unmeasured", _this36.contractForm.unmeasured || ''), (0, _defineProperty2.default)(_contractData, "contractTime", _this36.contractForm.contractTime || ''), (0, _defineProperty2.default)(_contractData, "signatureDate", _this36.contractForm.signatureDate || ''), (0, _defineProperty2.default)(_contractData, "scheduledDeliveryDate", _this36.contractForm.scheduledDeliveryDate || ''), (0, _defineProperty2.default)(_contractData, "agreedConstructionPeriod", _this36.contractForm.agreedConstructionPeriod || ''), (0, _defineProperty2.default)(_contractData, "contactPerson", _this36.contractForm.customerName), (0, _defineProperty2.default)(_contractData, "contactNumber", _this36.contractForm.customerPhone), (0, _defineProperty2.default)(_contractData, "contactAddress", _this36.contractForm.address), _contractData); // 根据是否有editingContractId判断是新增还是编辑

        if (_this36.editingContractId) {
          // 调用编辑合同接口
          (0, _cmsWorkOrder.editContract)(contractData).then(function (response) {
            if (response.code === 200) {
              _this36.showContractEditDialog = false;
              _this36.editingContractId = null;

              _this36.$message.success('合同编辑成功'); // 保存客户ID


              var _custId = _this36.contractForm.custId; // 清空合同图片上传组件

              if (_this36.$refs.contractImgUpload) {
                _this36.$refs.contractImgUpload.clearImgs();
              } // 清空合同附件上传组件


              if (_this36.$refs.contractFileUpload) {
                _this36.$refs.contractFileUpload.clearFiles();
              } // 隐藏合同表单


              _this36.showContractForm = false; // 刷新客户信息

              if (_custId) {
                (0, _cmsWorkOrder.getCustInfo)(_custId).then(function (response) {
                  if (response.code === 200) {
                    var latestCustomer = response.data;
                    _this36.currentCustomer = _objectSpread({}, latestCustomer); // 重新初始化表单数据

                    _this36.initFollowForm(latestCustomer); // 重新加载跟进记录


                    _this36.loadFollowRecords(latestCustomer.id); // 直接更新本地数据中的客户信息，不刷新页面


                    var index = _this36.crud.data.findIndex(function (c) {
                      return c.id === latestCustomer.id;
                    });

                    if (index !== -1) {
                      _this36.$set(_this36.crud.data, index, latestCustomer);
                    } // 刷新上传组件


                    if (_this36.$refs.basicInfo) {
                      _this36.$refs.basicInfo.init();
                    } // 强制更新合同管理数据


                    if (latestCustomer.contracts) {
                      _this36.customerForm.contracts = [];

                      _this36.$nextTick(function () {
                        _this36.customerForm.contracts = (0, _toConsumableArray2.default)(latestCustomer.contracts);
                      });
                    }
                  }
                }).catch(function (error) {});
              } // 重置合同表单


              _this36.contractForm = {
                id: '',
                contractNo: '',
                dealerCode: '',
                dealer: '',
                dealerShopCode: '',
                dealerShopName: '',
                type: '',
                customerName: '',
                customerPhone: '',
                contractAmount: 0,
                budgetAmount: 0,
                address: '',
                images: [],
                attachments: [],
                custId: '',
                file: ''
              };
            } else {
              // 处理错误响应
              _this36.$message.error(response.msg || '编辑合同失败');
            }
          }).catch(function (error) {
            console.error('编辑合同失败:', error);

            _this36.$message.error('编辑合同失败，请重试');
          });
        } else {
          // 调用新增合同接口
          (0, _cmsWorkOrder.addContract)(contractData).then(function (response) {
            if (response.code === 200) {
              _this36.showContractEditDialog = false;
              _this36.editingContractId = null;

              _this36.$message.success('合同新增成功'); // 保存客户ID


              var _custId2 = _this36.contractForm.custId || _this36.customerForm.id; // 清空合同图片上传组件


              if (_this36.$refs.contractImgUpload) {
                _this36.$refs.contractImgUpload.clearImgs();
              } // 清空合同附件上传组件


              if (_this36.$refs.contractFileUpload) {
                _this36.$refs.contractFileUpload.clearFiles();
              } // 重置合同表单


              _this36.contractForm = {
                id: '',
                contractNo: '',
                dealerCode: '',
                dealer: '',
                dealerShopCode: '',
                dealerShopName: '',
                type: '',
                customerName: '',
                customerPhone: '',
                contractAmount: 0,
                budgetAmount: 0,
                address: '',
                images: [],
                attachments: [],
                custId: '',
                file: ''
              }; // 隐藏合同表单

              _this36.showContractForm = false; // 刷新客户信息

              if (_custId2) {
                (0, _cmsWorkOrder.getCustInfo)(_custId2).then(function (response) {
                  if (response.code === 200) {
                    var latestCustomer = response.data;
                    _this36.currentCustomer = _objectSpread({}, latestCustomer); // 重新初始化表单数据

                    _this36.initFollowForm(latestCustomer); // 重新加载跟进记录


                    _this36.loadFollowRecords(latestCustomer.id); // 直接更新本地数据中的客户信息，不刷新页面


                    var index = _this36.crud.data.findIndex(function (c) {
                      return c.id === latestCustomer.id;
                    });

                    if (index !== -1) {
                      _this36.$set(_this36.crud.data, index, latestCustomer);
                    } // 刷新上传组件


                    if (_this36.$refs.basicInfo) {
                      _this36.$refs.basicInfo.init();
                    } // 强制更新合同管理数据


                    if (latestCustomer.contracts) {
                      _this36.customerForm.contracts = [];

                      _this36.$nextTick(function () {
                        _this36.customerForm.contracts = (0, _toConsumableArray2.default)(latestCustomer.contracts);
                      });
                    }
                  }
                }).catch(function (error) {});
              }
            } else {
              // 处理错误响应
              _this36.$message.error(response.msg || '新增合同失败');
            }
          }).catch(function (error) {
            console.error('新增合同失败:', error);

            _this36.$message.error('新增合同失败，请重试');
          });
        }
      } else {
        return false;
      }
    });
  }), (0, _defineProperty2.default)(_methods, "handleTabClick", function handleTabClick(tab) {
    // 切换标签页时加载对应数据
    if (tab.name === 'baseInfo') {
      // 客户信息标签页
      if (this.$refs.baseInfo) {
        this.$refs.baseInfo.init();
      }
    } else if (tab.name === 'basicInfo') {
      // 客户基本情况标签页
      if (this.$refs.basicInfo) {
        this.$refs.basicInfo.init();
      }
    } else if (tab.name === 'requirements') {
      // 客户需求标签页
      if (this.$refs.requirements) {
        this.$refs.requirements.init();
      }
    } else if (tab.name === 'storeInfo') {
      // 门店信息标签页
      if (this.$refs.storeInfo) {
        this.$refs.storeInfo.init();
      }
    } else if (tab.name === 'followInfo') {
      // 跟进标签页
      if (this.$refs.followInfo) {
        this.$refs.followInfo.init(this.currentCustomer.id, this.currentCustomer.followInfo && this.currentCustomer.followInfo.followId);
      }
    } else if (tab.name === 'special') {
      // 特殊申请标签页
      if (this.$refs.specialApply) {
        this.$refs.specialApply.initSpecialApplyList();
      }
    } else if (tab.name === 'design') {
      // 设计信息标签页
      if (this.$refs.contractDesignInfo) {
        this.$refs.contractDesignInfo.loadContractFiles();
      }
    } else if (tab.name === 'quotation') {
      // 报价信息标签页
      if (this.$refs.contractQuotationInfo) {
        this.$refs.contractQuotationInfo.init();
      }
    } else if (tab.name === 'afterInfo') {
      // 改补描述标签页
      if (this.$refs.contractAfterInfo) {
        this.$refs.contractAfterInfo.loadData();
      }
    }
  }), (0, _defineProperty2.default)(_methods, "initBaseInfoData", function initBaseInfoData() {
    if (this.currentCustomer) {
      this.followForm.baseInfo = {
        name: this.currentCustomer.name || '',
        mobile: this.currentCustomer.mobile || '',
        msgFrom: this.currentCustomer.msgFrom || '',
        address: this.currentCustomer.address || '',
        custWechat: this.currentCustomer.custWechat || '',
        isDistributor: this.currentCustomer.isDistributor || '',
        inviter: this.currentCustomer.inviter || '',
        zxFrom: this.currentCustomer.zxFrom || ''
      };
    }
  }), (0, _defineProperty2.default)(_methods, "initBasicInfoData", function initBasicInfoData() {
    if (this.currentCustomer) {
      var budgetImgs = [];

      if (this.currentCustomer.budgetImgs) {
        if (Array.isArray(this.currentCustomer.budgetImgs)) {
          budgetImgs = this.currentCustomer.budgetImgs;
        } else if (typeof this.currentCustomer.budgetImgs === 'string') {
          try {
            budgetImgs = JSON.parse(this.currentCustomer.budgetImgs);
          } catch (e) {
            console.error('解析 budgetImgs 失败:', e);
            budgetImgs = [];
          }
        }
      }

      var material = '';

      if (this.currentCustomer.material) {
        if (Array.isArray(this.currentCustomer.material)) {
          material = this.currentCustomer.material.join(', ');
        } else if (typeof this.currentCustomer.material === 'string') {
          material = this.currentCustomer.material;
        }
      }

      this.followForm.basicInfo = {
        focus: this.currentCustomer.styleFocus || '',
        needProduct1: this.currentCustomer.needProduct1 ? JSON.parse(this.currentCustomer.needProduct1) : [],
        needProduct2: this.currentCustomer.needProduct2 ? JSON.parse(this.currentCustomer.needProduct2) : [],
        needProduct3: this.currentCustomer.needProduct3 ? JSON.parse(this.currentCustomer.needProduct3) : [],
        budget: this.currentCustomer.budget || '',
        material: material,
        budgetImgs: budgetImgs,
        remark: this.currentCustomer.remarks || ''
      };
    }
  }), (0, _defineProperty2.default)(_methods, "initRequirementsData", function initRequirementsData() {
    if (this.currentCustomer) {
      this.followForm.requirements = {
        housePrice: this.currentCustomer.house_price || '',
        houseArea: this.currentCustomer.house_area || '',
        style: this.currentCustomer.like_style || '',
        moveInTime: this.currentCustomer.occupancy_time_limit || '',
        productNeed: this.currentCustomer.productNeed || '',
        customerFocus: this.currentCustomer.styleFocus || '',
        customerLevel: this.currentCustomer.customerLevel || '',
        decorationStatus: this.currentCustomer.decorationStatus || '',
        deliveryTime: this.currentCustomer.deliveryTime || '',
        decorationType: this.currentCustomer.decorationType || ''
      };
    }
  }), (0, _defineProperty2.default)(_methods, "initStoreInfoData", function initStoreInfoData() {
    if (this.currentCustomer) {
      var storeInto = this.currentCustomer.storeInto || {};
      var zxDept = this.currentCustomer.zxDept || {};
      this.followForm.storeInfo = {
        guide: storeInto.storeSeller || this.currentCustomer.storeSeller || this.currentCustomer.zxName || '',
        storeName: storeInto.storeName || this.currentCustomer.storeName || zxDept.name || this.currentCustomer.zxDeptName || '',
        remarks: storeInto.remarks || this.currentCustomer.remarks || '',
        storeManager: storeInto.storeManager || this.currentCustomer.storeManager || this.currentCustomer.zxManageName || this.currentCustomer.zxManage || ''
      };
    }
  }), _methods)
};
exports.default = _default;